import useUserStore from '@/stores/userStore';

interface UsePermissionResult {
  permissions: string[];
  hasPermission: (...required: string[]) => boolean;
  hasAnyPermission: (...candidates: string[]) => boolean;
}

const usePermission = (): UsePermissionResult => {
  const user = useUserStore((state) => state.user);
  const permissions = (user?.permissions ?? []) as string[];

  const hasPermission = (...required: string[]) => {
    if (!required.length) return true;
    return required.every((perm) => permissions.includes(perm));
  };

  const hasAnyPermission = (...candidates: string[]) => {
    if (!candidates.length) return true;
    return candidates.some((perm) => permissions.includes(perm));
  };

  return { permissions, hasPermission, hasAnyPermission };
};

export default usePermission;
